import { isRecord } from '@/utils/objects';
import type { DeviceNode } from '../types';
import { firstAndFilter, readFilterFields, toString } from './parse-helpers';

/**
 * Parse device conditions.
 * Handles: { event: { type: 'device_change', name, filters: { and: [to, from] } } }
 *          { type: 2, attribute_filter: { ... } }
 *          { type: 'device_attribute' | 'device_change', field, operator, value }
 */
export function parseDevice(raw: Record<string, unknown>): DeviceNode | null {
  // Ember format: { event: { type: 'device_change', name, filters } }
  const event = isRecord(raw.event) ? raw.event : undefined;
  if (event?.type === 'device_change') {
    return {
      type: 'device',
      field: toString(event.name) ?? 'device',
      ...readFilterFields(firstAndFilter(event)),
    };
  }

  // Backend format: { type: 2, attribute_filter: { ... } }
  if ((raw.type === 2 || raw.type === '2') && isRecord(raw.attribute_filter)) {
    const af = raw.attribute_filter;
    return {
      type: 'device',
      field: toString(af.attribute ?? af.field) ?? 'device',
      ...readFilterFields(af),
    };
  }

  // Direct format
  if (raw.type === 'device_attribute' || raw.type === 'device_change') {
    return {
      type: 'device',
      field: toString(raw.field ?? raw.attribute ?? raw.name) ?? 'device',
      ...readFilterFields(raw),
    };
  }

  return null;
}
